import { useState } from 'react';

export const useFilters = (initialStatuses = ['draft', 'completed'], initialCategories = [], initialModes = []) => {
  const [selectedStatuses, setSelectedStatuses] = useState(initialStatuses);
  const [selectedCategories, setSelectedCategories] = useState(initialCategories);
  const [selectedModes, setSelectedModes] = useState(initialModes);

  const handleToggle = (setter) => (value, checked) => {
    setter(prev => checked ? [...prev, value] : prev.filter(v => v !== value));
  };

  const handleStatusChange = handleToggle(setSelectedStatuses);
  const handleCategoryChange = handleToggle(setSelectedCategories);
  const handleModeChange = handleToggle(setSelectedModes);

  const clearAllFilters = () => {
    setSelectedStatuses([]);
    setSelectedCategories([]);
    setSelectedModes([]);
  };

  return {
    selectedStatuses,
    selectedCategories,
    selectedModes,
    handleStatusChange,
    handleCategoryChange,
    handleModeChange,
    clearAllFilters,
    setSelectedStatuses,
    setSelectedCategories,
    setSelectedModes
  };
};
